import React, { useState } from "react";
import { Typography, Button, Box, Grid, TextField, Snackbar, Alert, CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Layout from "./UserLayout";
import { formFieldStyles, labelStyles } from "../../styles/formStyles";
import { getUserDetails, logIn } from "../../services/User";
import { useAuth } from "../../auth/AuthProvider";
import { ILoginDTO, ILoginUserDetails } from "../../interfaces/User";

const Login = () => {
  const { login, setLoginUser} = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [fieldError, setFieldError] = useState({
    email: "",
    password: "",
  });
  const [loading,setLoading] = useState(false);
  const [errMsg, setErrMsg] = useState("");
  const [openError, setOpenError] = useState(false);

  const navigate = useNavigate();

  const validate = (): boolean => {
    let errors = { email: "", password: "" };
    let valid = true;

    if (!email) {
      errors.email = "Email is required";
      valid = false;
    } else if (!/^\S+@\S+\.\S+$/.test(email)) {
      errors.email = "Enter a valid email";
      valid = false;
    }

    if (!password) {
      errors.password = "Password is required";
      valid = false;
    }

    setFieldError(errors);
    return valid;
  };

  const handleLogin =async() => {
    if (!validate()) return;
    setLoading(true);
    try{
      const dto = {} as ILoginDTO;
      dto.email = email;
      dto.password = password;
      const response = await logIn(dto);    
      console.log("LoginRes",response)
      if(response && (response.status === "success" || response.status === "OK")){
      const info = response.rawResponse?.data;
      console.log("Signin response : ", info);
      if (info) {
        login(info.accessToken as string);

        const userDetailsRepsonse = await getUserDetails();
        console.log("User details response", userDetailsRepsonse);
        if (userDetailsRepsonse && userDetailsRepsonse.id) {
          console.log("inside if block", userDetailsRepsonse);
          setLoginUser(JSON.stringify(userDetailsRepsonse));
          navigate("/dashboard");
        }
      }
    }else if (response && response.status === "error"){
      const errMsg = response.errorResponse?.response?.data || response.errorResponse?.message || "Login Failed.";
      setErrMsg(errMsg);
      setOpenError(true);
      // navigate("/dashboard");
    }else{
      setOpenError(true);
      setErrMsg("Login Failed");
    }
    }catch(error){
      console.log("Error while login: ", error);
      setErrMsg("Network error. Please check your connection and try again.");
      setOpenError(true);
    }finally{
      setLoading(false);
    }
  };
  const handleSnackbarClose = () => {
    setOpenError(false);
  };
  return (
    <Layout>
      <Typography variant="h5" mb={1.5}>
        Log in
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography component="label" sx={labelStyles}>
            Email Address <span style={{ color: "#FE0909" }}>*</span>
          </Typography>
          <TextField
            fullWidth
            size="small"
            type="email"
            placeholder="Enter email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            error={!!fieldError.email}
            helperText={fieldError.email}
            sx={formFieldStyles}
          />
        </Grid>

        <Grid item xs={12}>
          <Typography component="label" sx={labelStyles}>
            Password <span style={{ color: "#FE0909" }}>*</span>
          </Typography>
          <TextField
            fullWidth
            size="small"
            type="password"
            placeholder="Enter password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            error={!!fieldError.password}
            helperText={fieldError.password}
            sx={formFieldStyles}
          />
        </Grid>

        <Grid item xs={12} mb={3}>
          <Box textAlign="right">
            <Typography
              onClick={() => navigate("/reset-password")}
              sx={{
                color: "#005EFF",
                fontSize: "13px",
                fontWeight: 500,
                cursor: "pointer",
                "&:hover": {
                  textDecoration: "underline",
                },
              }}
            >
              Forgot your password?
            </Typography>
          </Box>
        </Grid>

        <Grid item xs={12}>
          {!loading && (
          <Button
            onClick={handleLogin}
            fullWidth
            sx={{
              borderRadius: "6px",
              background: "#005EFF",
              boxShadow: "inset 0 0 10.7px rgba(0, 0, 0, 0.25)",
              color: "#fff",
              fontSize: "16px",
              fontWeight: 600,
              py: 1,
              textTransform: "none",
              "&:hover": {
                background: "#005EFF",
                boxShadow: "inset 0 0 10.7px rgba(0, 0, 0, 0.25)",
              },
            }}
            endIcon={<ArrowForwardIcon />}
          >
            Login
          </Button>
          )}
          {loading && (
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <CircularProgress />
            </Box>
          )}
        </Grid>

        <Grid item xs={12}>
          <Box textAlign="center">
            <Typography
              onClick={() => navigate("/signup")}
              sx={{
                color: "primary.main",
                fontSize: "16px",
                fontWeight: 500,
                cursor: "pointer",
                "&:hover": {
                  textDecoration: "underline",
                },
              }}
            >
              Create New Account
            </Typography>
          </Box>
        </Grid>
      </Grid>

      <Snackbar anchorOrigin={{ vertical: "top", horizontal: "right" }} open={openError} autoHideDuration={5000} onClose={handleSnackbarClose}>
        <Alert severity="error" variant="filled" sx={{ width: "100%" }}>{errMsg}</Alert>
      </Snackbar>
    </Layout>
  );
};

export default Login;
